import { useEffect, useState } from "react";
import { useUserProfile } from "@providers/profile";
import { SubscriptionStatus, HardwareSubscription } from "@providers/profile/ProfileProvider.model";

const useHardwareSubscription = () => {
  const {
    profileState: { profile, authToken },
    getSubscription,
    isLoggedIn,
  } = useUserProfile();
  const initialObject: HardwareSubscription = {
    customer_id: "",
    subscription_id: "",
    subscription_status: SubscriptionStatus.Initial,
    subscription_activation_date: "2019-08-24T14:15:22Z",
    paused: false,
    credit: 0,
    discount: {
      value: "",
      duration: "",
      frequency: 1,
    },
    next_billing_amount: 0,
    next_billing_date: "2019-08-24T14:15:22Z",
    final_billing_date: "2019-08-24T14:15:22Z",
    remaining_commitment_months: 0,
    auto_renew: true,
  };
  const [subscription, setSubscription] = useState(initialObject);

  useEffect(() => {
    const fetchSubscription = async () => {
      const data = await getSubscription(authToken, profile.email);
      setSubscription(data);
    };

    // Only fetch subscription if the user is logged in and has been fetched.
    if (isLoggedIn && profile.email) fetchSubscription();
  }, [profile]);

  return subscription;
};

export default useHardwareSubscription;
